import "./index.css";
import ReactDOM from "react-dom/client";
import { HeaderWithProvider, Footer } from "./App";
import { theme } from "./libs/theming";
import {
  ThemeProvider,
  CssBaseline,
  StyledEngineProvider,
} from "@mui/material";
import "./styles/global.css";

const header = ReactDOM.createRoot(document.getElementById("react-header"));
const footer = ReactDOM.createRoot(document.getElementById("react-footer"));

header.render(
  <ThemeProvider theme={theme}>
    <StyledEngineProvider injectFirst>
      <CssBaseline />
      <HeaderWithProvider />
    </StyledEngineProvider>
  </ThemeProvider>,
);

footer.render(
  <ThemeProvider theme={theme}>
    <StyledEngineProvider injectFirst>
      <CssBaseline />
      <Footer />
    </StyledEngineProvider>
  </ThemeProvider>,
);
